'use strict';

/**
 * Utility method to permit Array#reduce-like operations over objects
 *
 * This is likely to be slightly more inefficient than using lodash.reduce,
 * but results in ~50kb less size in the resulting bundled code before
 * minification and ~12kb of savings with minification.
 *
 * Unlike lodash.reduce(), the iterator and initial value properties are NOT
 * optional: this is done to simplify the code, this module is not intended to
 * be a full replacement for lodash.reduce and instead prioritizes simplicity
 * for a specific common case.
 *
 * @module util/object-reduce
 * @private
 * @param {Object} obj An object of key-value pairs
 * @param {Function} iterator A function to use to reduce the object
 * @param {*} initialState The initial value to pass to the reducer function
 * @returns The result of the reduction operation
 */
module.exports = function( obj, iterator, initialState ) {
	return Object.keys( obj ).reduce( function( memo, key ) {
		return iterator( memo, obj[ key ], key );
	}, initialState );
};



//////////////////
// WEBPACK FOOTER
// ./~/wpapi/lib/util/object-reduce.js
// module id = 65
// module chunks = 0